import React, { useState, useEffect } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { BiSolidEdit } from "react-icons/bi";
import { RiDeleteBin5Line } from "react-icons/ri";
import axios from "axios";
import { Circles } from 'react-loader-spinner';
import { FadeLoader } from 'react-spinners';


import { BaseUrl } from "../App";

const Pricing = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const serviceName = location.state?.serviceName || "Unknown Service";
  const serviceId = location.state?.serviceId;

  console.log(location.state);

  const [isCardVisible, setIsCardVisible] = useState(false);
  const [pricingMethod, setPricingMethod] = useState("");
  const [editServiceId, setEditServiceId] = useState(null);
  const [editServiceData, setEditServiceData] = useState(null);
  const [serviceStates, setServiceStates] = useState([]);
  console.log(serviceStates);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteServiceId, setDeleteServiceId] = useState(null);
  const [successMessage, setSuccessMessage] = useState("")
  const [error, setError] = useState("");

  useEffect(() => {
    let timer;
    if (error) {
      timer = setTimeout(() => {
        setError("");
      }, 5000); // 5 seconds
    }
    return () => clearTimeout(timer);
  }, [error]);
  // Fetch pricing data when the page loads or when the serviceId changes
  useEffect(() => {
    if (serviceId) {
      fetchPricingMethods(serviceId);
    }
  }, [serviceId]);

  // Fetch pricing methods for the selected service
  const fetchPricingMethods = async (serviceId) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/service_methods.php`,
        {
          action: "get_methods_of_selected_service",
          api_key: "1", // Replace with your actual API key
          service_id: serviceId,
        }
      );

      if (response.data.status === "true") {
        setServiceStates(response.data.response);
        console.log("api response", response.data); // Store pricing data in state
      } else {
        console.log("No pricing data found.");
      }
    } catch (error) {
      console.error("Error fetching pricing data:", error);
    }
     finally {
      setLoading(false);
    }
  };

  const handleEdit = (id) => {
    if (editServiceId === id) {
      setEditServiceId(null);
      setEditServiceData(null);
    } else {
      const serviceToEdit = serviceStates.find((service) => service.id === id);
      if (serviceToEdit) {
        setEditServiceId(id);
        setEditServiceData({ ...serviceToEdit });
      }
    }
  };

  const handleUpdate = async () => {
    setLoading(true);
    if (editServiceData) {
      try {
        const response = await axios.post(
          `${BaseUrl}/backend/api/service_methods.php`,
          {
            action: "update_service_method",
            api_key: "1", // Replace with your actual API key
            id: editServiceId,
            method_title: editServiceData.method_title, // Ensure method_title is updated
          }
        );

        if (response.data.status === "true") {
          setSuccessMessage("Update Service Method Successfully!")
          // Success: Update the service method in the state
          setServiceStates((prevState) =>
            prevState.map((service) =>
              service.id === editServiceId
                ? { ...service, method_title: editServiceData.method_title }
                : service
            )
          );
          setEditServiceId(null);
          setEditServiceData(null);
          console.log("Service method updated successfully.", response.data);
        } else {
          console.error(
            "Failed to update service method:",
            response.data.response
          );
        }
      } catch (error) {
        console.error("Error updating service method:", error);
      }
        finally {
          setLoading(false);
        }
    }
  };
  
  const handleReset = () => {
    const originalService = serviceStates.find(
      (service) => service.id === editServiceId
    );
    if (originalService) {
      setEditServiceData({ ...originalService });
    }
  };

  const handleSavePricing = async () => {
    setLoading(true);
    if (pricingMethod.trim()) {
      const newService = {
        method_title: pricingMethod, // The name of the pricing method
        service_id: serviceId, // The ID of the service
        status: "D", // You can set the status based on your needs (defaulting to 'active' for now)
        api_key: "1", // Replace with your actual API key
      };

      try {
        const response = await axios.post(
          `${BaseUrl}/backend/api/service_methods.php`,
          {
            action: "add_service_method",
            ...newService, // Spread the newService object here
          }
        );

        if (response.data.status === "true") {
          setSuccessMessage("Add Pricing Method Successfully!")
          // Success: Add the new service method to the state
          setServiceStates([
            ...serviceStates,
            { id: Date.now(), method_title: pricingMethod, enabled: true }, // You can adjust the response accordingly
          ]);
          setPricingMethod(""); // Clear the input field
          setIsCardVisible(false);
          console.log("api resaponse", response.data); // Close the "Add Pricing Method" card
        } else {
          // Error handling if the API response status is not 'true'
          console.error(
            "Failed to add service method:",
            response.data.response
          );
        }
      } catch (error) {
        console.error("Error adding pricing method:", error);
      }
      finally {
        setLoading(false);
      }
    }
  };
  const handleDelete = async () => {
    setLoading(true);
    try {
      // Send a request to the backend to delete the service method
      const response = await axios.post(
        `${BaseUrl}/backend/api/service_methods.php`,
        {
          action: "delete_service_method",
          api_key: "1", // Replace with your actual API key
          id: deleteServiceId, // Pass the service ID to be deleted
        }
      );

      if (response.data.status === "true") {
        setSuccessMessage("Delete Pricing Method Successfully!")
        // On success, remove the service method from the local state
        setServiceStates((prevState) =>
          prevState.filter((service) => service.id !== deleteServiceId)
        );
        setDeleteServiceId(null); // Clear the delete service ID
        setIsDeleteModalVisible(false); // Close the delete confirmation modal
        console.log("Service method deleted successfully.", response.data);
      } else {
        // Handle error if deletion fails
        console.error(
          "Failed to delete service method:",
          response.data.response
        );
      }
    } catch (error) {
      console.error("Error deleting service method:", error);
    }
    finally {
      setLoading(false);
    }
  };

  // This function will now only update the local state and call the API via `toggleServiceStatus`
  const toggleService = (id, currentStatus) => {
    const newStatus = currentStatus ? "E" : "D"; // E for enabled, D for disabled // Toggle the status between 'D' and 'E'
    // const newStatus = service.enabled ? "E" : "D"; // E for enabled, D for disabled
    // Call the API to change the service status
    toggleServiceStatus(id, newStatus); // API call for changing status

    // Update the local state based on the new status
    setServiceStates((prevState) =>
      prevState.map((service) =>
        service.id === id
    ? { ...service, enabled: !service.enabled } // Toggle the 'enabled' state
    : service
      )
    );
  };

  const toggleServiceStatus = async (id, currentStatus) => {
    setLoading(true);
    const newStatus =  currentStatus ? "E" : "D";

    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/service_methods.php`,
        {
          action: "change_service_method_status",
          api_key: "1", // Replace with your actual API key
          id: id,
          status: newStatus,
        }
      );

      if (response.data.status === "true") {
        setSuccessMessage("Change Status Service Method Successfully!")
        // Handle success (e.g., update the UI to reflect the new status)
        console.log("Service status updated successfully", response.data);
      } else {
        // Handle failure
        console.error("Error updating service status:", response.data.response);
      }
    } catch (error) {
      console.error("Error making API request:", error);
    }
    finally {
      setLoading(false);
    }
  };

  const handleClick = (methodId) => {
    // Find the specific method from serviceStates using the method ID
    const selectedMethod = serviceStates.find(
        (service) => service.id === methodId
    );

    if (selectedMethod) {
        navigate("addunit", {
            state: {
                method_title: selectedMethod.method_title,
                serviceId: serviceId,        // The parent service ID
                methods_id: selectedMethod.id // The specific method ID
            },
        });
    } else {
        console.error("Method not found for ID:", methodId);
    }
};

  return (
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         
        <div className="container mx-auto px-4 py-6">
                  {successMessage && (
            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
              <span className="block sm:inline">{successMessage}</span>
            </div>
          )}

          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
              <span className="block sm:inline">{error}</span>
            </div>
          )}

          {/* Display navigation trail */}
          <div className="mb-4">
            <Link to="/admin/service" className="text-blue-500 hover:underline">
              Services
            </Link>
            <span className="mx-2">→</span>
            <span className="text-gray-700">{serviceName}</span>
          </div>

          <h1 className="text-2xl font-bold mb-4">Pricing for {serviceName}</h1>
          <span className="flex ml-auto justify-end">
            <button
              onClick={() => setIsCardVisible(!isCardVisible)}
              className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition mb-4"
            >
              + Add Pricing Method
            </button>
          </span>

          {isCardVisible && (
            <div className="border border-gray-300 p-4 rounded-lg shadow-md bg-white mb-4">
              <label className="block text-sm font-medium mb-2">
                Method Name
              </label>
              <input
                type="text"
                value={pricingMethod}
                onChange={(e) => setPricingMethod(e.target.value)}
                placeholder="Enter pricing method"
                className="w-full px-4 py-2 border rounded-md mb-4"
              />
              <div className="flex justify-end space-x-2">
                <button
                  onClick={() => setIsCardVisible(false)}
                  className="px-4 py-2 bg-gray-500 text-white rounded-md"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSavePricing}
                  className="px-4 py-2 bg-green-500 text-white rounded-md"
                >
                  Save
                </button>
              </div>
            </div>
          )}

          {serviceStates.map((service) => (
            <div
              key={service.id}
              className="border-b-4 rounded-md border-gray-300 py-4"
            >
              <div className="flex flex-row items-center">
                <span>{service.method_title}</span>
                <span className="justify-end px-4 ml-auto gap-3 flex flex-row">
                  <button
                    onClick={() => handleClick(service.id)}
                    className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                  >
                    Unit Pricing
                  </button>
                  {/* Toggle Button */}
                  <button
                    onClick={() =>
                      toggleService(service.id, service.status === "E")
                    }
                    className={`relative w-12 h-6 rounded-full transition-all duration-300 flex items-center justify-center text-sm ${
                      service.status === "E"
                        ? "bg-green-500 text-white"
                        : "bg-red-500 text-white"
                    }`}
                  >
                    <div
                      className={`w-6 h-6 bg-white rounded-full absolute top-0 transition-all ${
                        service.status === "E" ? "right-0.5" : "left-0.5"
                      }`}
                    />
                  </button>

                  <RiDeleteBin5Line
                    onClick={() => {
                      setDeleteServiceId(service.id);
                      setIsDeleteModalVisible(true);
                    }}
                    className="w-8 h-8 cursor-pointer text-red-500 hover:opacity-80"
                  />
                  <BiSolidEdit
                    onClick={() => handleEdit(service.id)}
                    className="w-8 h-8 cursor-pointer text-blue-500 hover:opacity-80"
                  />
                </span>
              </div>

              {editServiceId === service.id && (
                <div className="border-t border-gray-300 pt-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="mb-4">
                      <label className="block text-sm font-medium mb-2">
                        Method Name
                      </label>
                      <input
                        type="text"
                        value={editServiceData?.method_title || ""} // Ensure it is `method_title` from editServiceData
                        onChange={(e) =>
                          setEditServiceData({
                            ...editServiceData,
                            method_title: e.target.value, // Update method_title instead of name
                          })
                        }
                        className="w-full px-4 py-2 border rounded-md"
                      />
                    </div>
                  </div>
                  <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-2">
                    <button
                      onClick={handleUpdate}
                      className="w-full sm:w-auto px-4 py-2 bg-green-500 text-white rounded-md"
                    >
                      Update
                    </button>
                    <button
                      onClick={handleReset}
                      className="w-full sm:w-auto px-4 py-2 bg-gray-500 text-white rounded-md"
                    >
                      Reset
                    </button>
                  </div>
                </div>
              )}
            </div>
          ))}

          {isDeleteModalVisible && (
            <div className="fixed inset-0 z-50 bg-gray-800 bg-opacity-75 flex items-center justify-center p-4">
              <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md mx-4">
                <h2 className="text-lg font-medium mb-4">Confirm Delete</h2>
                <p className="text-sm sm:text-base">
                  Are you sure you want to delete this service?
                </p>
                <div className="flex justify-end space-x-2 mt-4">
                  <button
                    onClick={() => setIsDeleteModalVisible(false)}
                    className="px-4 py-2 bg-gray-500 text-white rounded-md text-sm sm:text-base"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleDelete}
                    className="px-4 py-2 bg-red-500 text-white rounded-md text-sm sm:text-base"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          )}
          {isDeleteModalVisible && (
            <div className="fixed inset-0 z-50 bg-gray-800 bg-opacity-75 flex items-center justify-center p-4">
              <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md mx-4">
                <h2 className="text-lg font-medium mb-4">Confirm Delete</h2>
                <p className="text-sm sm:text-base">
                  Are you sure you want to delete this service?
                </p>
                <div className="flex justify-end space-x-2 mt-4">
                  <button
                    onClick={() => setIsDeleteModalVisible(false)}
                    className="px-4 py-2 bg-gray-500 text-white rounded-md text-sm sm:text-base"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleDelete}
                    className="px-4 py-2 bg-red-500 text-white rounded-md text-sm sm:text-base"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
     
    </div>
  );
};

export default Pricing;

